import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: '',
    accountId: '',
    uniqueId: '',
    actInfo: {},
    actExtend: {},
    accessid: '',
    openid: '',
    totalPage: 0,
    currPage: 1, //当前已经看到的视频页码（每页1个，即看到了第几个视频）
    currLessionInfo: {}, //当前视频信息

    videoIndex: 0, //当前活动抽取的所有视频，目前已经观看的视频序号
    videoData: [],  //当前活动抽取的所有视频

    currQnum: 0, //当前视频对应的所有问题，目前已经答到的问题序号
    currQuestions: [],  //当前视频对应的所有问题
    correctAnswer: {},  //所有正确答案
    answerData: [],
    lotteryInfo: {}, //抽奖活动信息
    cateData:[],
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token;
    },
    SET_ACCOUNTID(state, accountId) {
      state.accountId = accountId;
    },
    SET_UNIQUEID(state, uniqueId) {
      state.uniqueId = uniqueId;
    },
    SET_ACTINFO(state, actInfo) {
      state.actInfo = actInfo;
    },
    SET_ACTEXTEND(state, actExtend) {
      state.actExtend = actExtend;
    },
    SET_ACCESSID(state, accessid) {
      state.accessid = accessid;
    },
    SET_OPENID(state, openid) {
      state.openid = openid;
    },
    SET_TOTALPAGE(state, totalPage) {
      state.totalPage = totalPage;
    },
    SET_CURRPAGE(state, currPage) {
      state.currPage = currPage;
    },
    SET_CURRLESSIONINFO(state, currLessionInfo) {
      state.currLessionInfo = currLessionInfo;
    },
    SET_VIDEOINDEX(state, videoIndex) {
      state.videoIndex = videoIndex;
    },
    SET_VIDEODATA(state, videoData) {
      state.videoData = videoData;
    },
    SET_CURRQNUM(state, currQnum) {
      state.currQnum = currQnum;
    },
    SET_CURRQUESTIONS(state, currQuestions) {
      state.currQuestions = currQuestions;
    },
    SET_CORRECTANSWER(state, correctAnswer) {
      state.correctAnswer = correctAnswer;
    },
    SET_ANSWERDATA(state, answerData) {
      state.answerData = answerData;
    },

    SET_LOTTERYINFO(state, lotteryInfo) {
      state.lotteryInfo = lotteryInfo;
    },
    SET_CATEDATA(state, cateData) {
      state.cateData = cateData;
    },


  },
  actions: {
  },
  modules: {
  },
  getters: {
  }
})
